<template>
  <div class="cards-grid">
    <div
      v-for="(value, index) in cards"
      :key="index"
      class="item"
      :style="{
        height: iHeight,
        width: iWidth,
      }"
      :class="{ active: selectedElementIndex == index }"
    >
      <div class="card-tools" v-show="!viewOnly">
        <i
          v-if="selectedElementIndex == index"
          class="fa fa-times fa-lg"
          style="font-size: 18px; padding-right: 2px"
          @click="toggleSelectedElement(index)"
        ></i>
        <i v-else class="fas fa-edit" @click="toggleSelectedElement(index)"></i>
        <i class="fas fa-trash-alt" @click="removeItem(index)"></i>
      </div>

      <div class="row" v-for="(val, key, idx) in sortKeysAsSchemaOrder(cards[index])" :key="idx">
        <!-- Not editable -->
        <span v-if="selectedElementIndex != index"
          >{{ getCardInfo(key, 'label') }} : {{ val }}</span
        >

        <!-- Editable -->
        <span v-show="selectedElementIndex == index"
          >{{ getCardInfo(key, 'label') }} :</span
        >
        <input
          v-if="getCardInfo(key, 'type') != 'number'"
          v-show="selectedElementIndex == index"
          :type="getCardInfo(key, 'type')"
          v-model="cards[index][key]"
        />
        <input
          v-else
          v-show="selectedElementIndex == index"
          :type="getCardInfo(key, 'type')"
          v-model.number="cards[index][key]"
          :step="getSteps(key)"
        />
      </div>
    </div>
    <div class="add-button-wrapper" v-if="!viewOnly">
      <div class="add-button" @click="addItem">+</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cards-component',
  data() {
    return {
      selectedElementIndex: null,
    };
  },
  props: ['schema', 'cards', 'itemWidth', 'itemHeight', 'viewOnly'],
  methods: {
    getCardInfo: function (key, prop) {
      const schemaFilter = this.schema.filter((e) => e.name === key);
      return schemaFilter.length ? schemaFilter[0][prop] : null;
    },
    sortKeysAsSchemaOrder(card){
      return  JSON.parse(JSON.stringify(card, this.keyOrderFromSchema))
    },
    getSteps: function (key) {
      let card = this.schema.filter((e) => e.name == key)[0];
      if (card.attributes.hasOwnProperty('step')) return card.attributes.step;
      else return 0;
    },
    addItem: function () {
      let item = {};

      for (let i of this.schema) {
        item[i.name] = i['value'];
      }

      //this.$emit('setListItem', i)
      this.cards.splice(this.cards.length, 1, item);
      //this.$set(this.cards, this.cards.length, item)
    },
    removeItem: function (index) {
      this.cards.splice(index, 1);
    },
    toggleSelectedElement: function (i) {
      if (this.selectedElementIndex == i) this.selectedElementIndex = null;
      else this.selectedElementIndex = i;
    },
  },
  computed: {
    iWidth() {
      if (this.itemWidth) return this.itemWidth;
      return 'fit-content';
    },
    iHeight() {
      if (this.itemHeight) return this.itemHeight;
      return 'fit-content';
    },
    keyOrderFromSchema(){
      return this.schema.map((e) => e.name)
    },
  },
};
</script>

<style scoped>
.cards-grid .item {
  display: inline-grid;
  background: #ffffff;
  margin-right: 8px;
  margin-bottom: 15px;
  cursor: pointer !important;
  text-align: center !important;
  border: 1px solid rgb(221, 221, 221) !important;
  background-color: rgb(255, 255, 255) !important;
  outline: none !important;
  font-family: Circular, -apple-system, BlinkMacSystemFont, Roboto,
    'Helvetica Neue', sans-serif !important;
  transition-property: -ms-transform, -webkit-transform, transform,
    background-color, border-color !important;
  transition-duration: 0.15s !important;
  padding: 17px 47px 17px 17px !important;
  border-radius: 19px !important;
  font-size: 15px !important;
  color: var(--brand-color-dark) !important;
  text-align: left !important;
  padding: 25px !important;
}

.cards-grid .item .card-tools {
  text-align: right;
}

.cards-grid .item .card-tools i {
  margin-left: 5px;
}

.cards-grid .item input {
  margin-left: 3px;
  padding-left: 5px;
  border-radius: 5px;
  border: solid 1px;
  background: rgb(247, 247, 247);
  width: min-content;
}

.cards-grid .item img {
  width: 34px;
  margin-bottom: 39px;
}

.cards-grid .item:hover {
  color: var(--brand-color-dark) !important;
  border-color: var(--bbrand-color-darklue) !important;
}

.cards-grid .item.active {
  background-color: rgb(247, 247, 247) !important;
  border-color: var(--brand-color-dark) !important;
  border: 2px solid !important;
}

.cards-grid .item span {
  margin: 0;
}

:root {
  --brand-color-dark: black;
}
</style>
